import {Base} from '../../common/model/base.model';
import {GeoComune} from '../geocomune/geo-comune.model';

export class GeoCap extends Base {

  constructor(protected id: number,
              public cap: string,
              public comune: GeoComune
  ) {
    super(id);
  }

  public getLabel() {
    if (this.comune) {
      return this.cap + ' - ' + this.comune.getLabel();
    }
    return this.cap;
  }

}
